import {
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { useAuth } from "../auth/useAuth";

export default function OrgSwitcher() {
  const { organizations, activeOrg, switchOrg } = useAuth();

  return (
    <FormControl fullWidth size="small">
      <Select
        value={activeOrg?.id || ""}
        onChange={(e) =>
          switchOrg(organizations.find((o) => o.id === e.target.value))
        }
        displayEmpty
        IconComponent={KeyboardArrowDownRoundedIcon}
        sx={{
          borderRadius: 3,
          color: "#F8FAFC",
          backgroundColor: "rgba(255,255,255,0.06)",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(148, 163, 184, 0.18)",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(103, 232, 249, 0.24)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(103, 232, 249, 0.34)",
          },
          "& .MuiSelect-icon": {
            color: "#BAE6FD",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              background:"#1f5359",
              mt: 1,
              borderRadius: 3,
              border: "1px solid rgba(226, 232, 240, 0.9)",
              boxShadow: "0 24px 60px rgba(15, 23, 42, 0.12)",
            },
          },
        }}
        renderValue={(selected) => {
          const org = organizations.find((item) => item.id === selected);
          return (
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontSize: 13, color: "#94A3B8" }}>
                Workspace
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: "#F8FAFC",
                  overflowWrap: "anywhere",
                }}
              >
                {org?.name || "Select organization"}
              </Typography>
            </Box>
          );
        }}
      >
        {organizations.map((org) => (
          <MenuItem key={org.id} value={org.id} sx={{color:"#fff"}}>
            {org.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
